export const CLASSNAME = 'block-video';
